import { ASSETS, CONTACT } from "@/data/landingData";
import LanguageToggle from "@/components/landing/LanguageToggle";
import { useLanguage } from "@/context/LanguageContext";

const scrollToSection = (sectionId) => (event) => {
  if (!sectionId || typeof document === "undefined") {
    return;
  }
  event.preventDefault();
  const target = document.getElementById(sectionId);
  if (target) {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const behavior = prefersReducedMotion ? "auto" : "smooth";
    target.scrollIntoView({ behavior, block: "start" });
    window.setTimeout(() => {
      target.scrollIntoView({ behavior, block: "start" });
    }, 250);
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", `#${sectionId}`);
    }
  }
};

const LandingHeader = () => {
  const { copy } = useLanguage();

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-left" data-testid="header-logo-wrapper">
        <img
          src={ASSETS.logoMain}
          alt="Nexus Benin SAS"
          className="logo"
          data-testid="header-logo"
          loading="lazy"
        />
      </div>
      <nav className="nav" data-testid="header-navigation">
        <a href="#solutions" data-testid="nav-solutions-link" onClick={scrollToSection("solutions")}>
          {copy.header.nav.solutions}
        </a>
        <a href="#avantages" data-testid="nav-avantages-link" onClick={scrollToSection("avantages")}>
          {copy.header.nav.highlights}
        </a>
        <a href="#ressources" data-testid="nav-resources-link" onClick={scrollToSection("ressources")}>
          {copy.header.nav.resources}
        </a>
        <a href="#success" data-testid="nav-success-link" onClick={scrollToSection("success")}>
          {copy.header.nav.success}
        </a>
        <a href="#investir" data-testid="nav-investir-link" onClick={scrollToSection("investir")}>
          {copy.header.nav.invest}
        </a>
        <a href="#donate" data-testid="nav-donate-link" onClick={scrollToSection("donate")}>
          {copy.header.nav.donate}
        </a>
        <a href="#contact" data-testid="nav-contact-link" onClick={scrollToSection("contact")}>
          {copy.header.nav.contact}
        </a>
      </nav>
      <div className="header-actions" data-testid="header-actions">
        <LanguageToggle />
        <a
          className="cta-button"
          href={CONTACT.whatsappLink}
          target="_blank"
          rel="noreferrer"
          data-testid="header-whatsapp-button"
        >
          {copy.header.whatsapp}
        </a>
      </div>
    </header>
  );
};

export default LandingHeader;